import 'htmx.org/dist/htmx.js';

window.SiteReady(($) => {

  console.log('Init Block: Job Board');

  window.resetFilterForm = function() {
    let $form = $('.js-job_board_form');

    $form.find('input[type="checkbox"]').prop('checked', false);
    $form.find('input[type="text"], input[type="date"]').val('');
  };

});